import React from 'react'

export const UALContext = React.createContext()
